import React, { useState } from "react";
import headerlogo from "assets/img/headerlogo.png";
import { Link } from "react-router-dom";
import mflogo from "assets/img/mflogo.png";
import headericon1 from "assets/img/headericon1 (1).png";
import headericon2 from "assets/img/headericon2 (1).png";
import headericon3 from "assets/img/headericon3 (1).png";
import header4 from "assets/img/header4.png";

const NavMobile = () => {
  const [showFirstStep, setShowFirstStep] = useState(false);
  const [showSecondStep, setShowSecondStep] = useState(false);
  const [showGroupTourStep, setShowGroupTourStep] = useState(false);

  const renderItem = () => {
    return (
      <div className="banner-font font-semibold text-white mb-60">
        <ul>
          <li className="py-6 border-b">
            <a href="/">HOME</a>
          </li>
          <li
            onClick={onClickGroupTour}
            className="flex justify-between py-6 border-b"
          >
            <span onClick={onClickGroupTour}>PRODUCTS</span>
            <p className="font-extrabold">⌵</p>
          </li>
          <li className="py-6 border-b">
            <a href="/quality">QUALITY</a>
          </li>
          <li className="py-6 border-b">
            <a href="/service">SERVICE</a>
          </li>
          <li className="py-6 border-b">
            <a href="/about-us">ABOUT</a>
          </li>
          <li className="py-6 border-b">
            <a href="/contact-us">CONTACT</a>
          </li>
        </ul>
      </div>
    );
  };

  const onClickDestinations = () => {
    setShowFirstStep(false);
    setShowSecondStep(true);
    setShowGroupTourStep(false);
  };

  const onClickGroupTour = () => {
    setShowFirstStep(false);
    setShowSecondStep(false);
    setShowGroupTourStep(true);
  };

  const onClickBackButton = () => {
    setShowFirstStep(true);
    setShowSecondStep(false);
    setShowGroupTourStep(false);
  };

  const onClickClose = () => {
    setShowFirstStep(false);
    setShowSecondStep(false);
    setShowGroupTourStep(false);
    document.body.style.backgroundColor = "";
  };

  return (
    <nav className="top-0 fixed z-10 w-full flex flex-wrap items-center justify-between navbar-expand-lg lg:hidden md:block block ">
      <div className="bg-white overflow-hidden container pr-4 flex flex-wrap items-center justify-between">
        <div className="w-full relative items-center flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
          <Link to="/homepage">
            <div className="flex">
              <div className="bg-white">
                <img
                  className="w-48 md:w-48 p-2"
                  src={mflogo}
                  alt="App Development Company in Bangalore"
                />
              </div>
            </div>
          </Link>
          <div
            className="text-dark font-bold  p-4 rounded-xl"
            onClick={() => setShowFirstStep(true)}
          >
            ☰
          </div>
        </div>
      </div>
      {showFirstStep && (
        <div
          className={`z-50 -mt-18 w-full ${
            showFirstStep || showSecondStep || showGroupTourStep
              ? "animate-slide-left"
              : "animate-slide-right"
          }`}
          style={{
            backgroundColor:
              showFirstStep || showSecondStep || showGroupTourStep
                ? ""
                : "bg-black",
          }}
        >
          <div className="bg-dark py-6 px-6">
            <div className="flex justify-between">
              <div></div>
              <div onClick={onClickClose} className="text-white font-extrabold">
                ✕
              </div>
            </div>
            <div className=" text-white w-full md:w-8/12 banner-font text-base">
              {/* <img src={eclogohead} className="w-12 mb-2" />
              <span>
                <b>Deliciko </b> is a trusted IT consultancy in Bangalore,
                offering top-notch services for businesses.
              </span> */}
            </div>
          </div>
          <ul className="flex bg-dark flex-col py-2 md:py-0 px-6 space-y-1">
            {renderItem()}
          </ul>
          <div className="flex justify-between items-center mt-4 mx-4"></div>
        </div>
      )}

      {showSecondStep && (
        <>
          <div className="z-51 overflow-y-auto w-full bg-dark animate-slide-left -mt-20">
            <div className="py-8 px-4 flex items-center bg-gray-100 ">
              <div
                className="ml-2 h-6 w-6 text-white cursor-pointer top-2"
                aria-hidden="true"
                onClick={onClickBackButton}
              >
                <span className="font-extrabold">〱</span>
              </div>
              <h1 className="font1 text-white w-full px-4 font-semibold uppercase tracking-wide text-sm hover:bg-neutral-100 dark:hover:bg-neutral-800 rounded-lg">
                Services
              </h1>
            </div>
          </div>
          <div className="pb-32 px-6 mb-16 animate-slide-left">
            <div className="flex">
              <div className="lg:w-3/12 md:w-00/12 w-3/12"></div>
              <div className="lg:w-7/12 md:w-7/12 pt-2">
                <a href="/service">
                  <h1 className="font-semibold text-sm banner-font text-white">
                    Web Design
                  </h1>
                  <p className="text-xs text-white head1 pt-2">
                    We are deliver a high quality services and success for any
                    business.
                  </p>
                </a>
              </div>
            </div>
            <div className="flex pt-6">
              <div className="lg:w-3/12 md:w-00/12 w-3/12  "></div>
              <div className="lg:w-7/12 md:w-7/12 pt-2">
                <a href="/service">
                  <h1 className="font-semibold text-smbanner-font text-white">
                    Web Development
                  </h1>
                  <p className="text-xs text-charcoal400 pt-2 head1">
                    We Develop your website with the latest trends based on your
                    needs.
                  </p>
                </a>
              </div>
            </div>
            <div className="flex  pt-6 ">
              <div className="lg:w-3/12 md:w-00/12 w-3/12  "></div>
              <div className="lg:w-7/12 md:w-7/12 pt-2">
                <a href="/service">
                  <h1 className="font-semibold text-smbanner-font text-white">
                    Marketing
                  </h1>
                  <p className="text-xs text-charcoal400 pt-2">
                    Our team understands the need of our clients to generate
                    better results.
                  </p>
                </a>
              </div>
            </div>
            <div className="flex pt-6">
              <div className="lg:w-3/12 md:w-00/12 w-3/12  "></div>
              <div className="lg:w-7/12 md:w-7/12 pt-2">
                <a href="/service">
                  <h1 className="font-semibold text-smbanner-font text-white">
                    App Development
                  </h1>
                  <p className="text-xs text-charcoal400 pt-2">
                    This is a functional piece of software driven by dynamic and
                    interactive.
                  </p>
                </a>
              </div>
            </div>
            <div className="flex pt-6">
              <div className="lg:w-3/12 md:w-00/12 w-3/12  ">
                {/* <img className="w-20" src={ECOMMERCE} alt="..." /> */}
              </div>
              <div className="lg:w-7/12 md:w-7/12 pt-2">
                <a href="/service">
                  <h1 className="font-semibold text-smbanner-font text-white">
                    E-Commerce
                  </h1>
                  <p className="text-xs text-charcoal400 pt-2 hover:text-lightBlue-600:hover">
                    We will technology establish effective connect with your
                    target audience.
                  </p>
                </a>
              </div>
            </div>
          </div>
        </>
      )}

      {showGroupTourStep && (
        <>
          <div className="overflow-y-auto w-full bg-dark animate-slide-left -mt-20">
            <div className="py-8 px-4 mt-16 flex items-center bg-gray-100 ">
              <div
                className="ml-2 h-6 w-6 text-neutral-500 cursor-pointer top-2"
                aria-hidden="true"
                onClick={onClickBackButton}
              >
                <span className="font-extrabold text-white">〱</span>
              </div>
              <h1 className="text-white font1 w-full px-4 font-semibold uppercase tracking-wide text-sm hover:bg-neutral-100 dark:hover:bg-neutral-800 rounded-lg">
                About Us
              </h1>
            </div>
          </div>
          <div className="pb-48 px-6 mb-16 bg-dark animate-slide-left">
            <div className="flex">
              <div className="lg:w-3/12 md:w-2/12 w-3/12  ">
                <img
                  className="w-24 bg-white  p-3"
                  src={headericon1}
                  alt="..."
                />
              </div>
              <div className="lg:w-7/12 md:w-7/12 pt-0 pl-4">
                <a href="/products">
                  <h1 className="font-semibold text-2xl text-white">
                    Cephalopodes
                  </h1>
                  <p className="text-base text-charcoal400 head1 pt-2">
                    Octopuses, squids, and cuttlefish
                  </p>
                </a>
              </div>
            </div>
            <div className="flex pt-6">
              <div className="lg:w-3/12 md:w-2/12 w-3/12  ">
                <img
                  className="w-24 bg-white  p-3"
                  src={headericon2}
                  alt="..."
                />
              </div>
              <div className="lg:w-7/12 md:w-7/12 pt-0 pl-4 md:pl-4">
                <a href="/products">
                  <h1 className="font-semibold text-2xl text-white">
                    Wild Fish
                  </h1>
                  <p className="text-base text-charcoal400 pt-2 head1">
                    Whiteleg Shrimp, squids, cuttlefish
                  </p>
                </a>
              </div>
            </div>
            <div className="flex  pt-6 ">
              <div className="lg:w-3/12 md:w-2/12 w-3/12  ">
                <img
                  className="w-24 bg-white  p-3"
                  src={headericon3}
                  alt="..."
                />
              </div>
              <div className="lg:w-7/12 md:w-7/12 pt-0 pl-4">
                <a href="/products">
                  <h1 className="font-semibold text-2xl text-white">
                    Crustacean
                  </h1>
                  <p className="text-base text-charcoal400 pt-2">
                    Seabream, seabass, bluefin tuna
                  </p>
                </a>
              </div>
            </div>
            <div className="flex pt-6 ">
              <div className="lg:w-3/12 md:w-2/12 w-3/12  ">
                <img className="w-24 bg-white  p-3" src={header4} alt="..." />
              </div>
              <div className="lg:w-7/12 md:w-7/12 pt-0 pl-4">
                <a href="/products">
                  <h1 className="font-semibold text-2xl text-white">
                    Farmed Fish
                  </h1>
                  <p className="text-base text-charcoal400 pt-2">
                    Red mullet, bonito, swordfish
                  </p>
                </a>
              </div>
            </div>
          </div>
        </>
      )}
    </nav>
  );
};

export default NavMobile;
